import React from 'react'
import { useNavigate } from 'react-router-dom';
import Button from '../../Subcomponents/Button';
import Datagrid from '../../Subcomponents/Datagrid';
import SearchBar from '../../Subcomponents/Search';
import cssClasses from './SelectProject.module.css'
import AddIcon from '@mui/icons-material/Add';

export default function SelectProject({ setSearchProject, pageChanged, allProjects, projectGridColums }) {
    const navigate = useNavigate()

    return (
        <div className={cssClasses.mainContainer}>
            <div className={cssClasses.content}>
                <div className={cssClasses.actionWrapper}>
                    <div className={cssClasses.searchWrapper} style={{ marginBottom: "1.6rem" }}>
                        <SearchBar placeholder={"Search by project name"} search={(e) => { setSearchProject(e.target.value) }} id={'projectSearchBar'} />
                    </div>
                    {/* <div className={cssClasses.btnWrapper} style={{ marginBottom: "1.6rem" }}>
                        <Button clicked={() => { navigate('/home/Event/') }} btnName={'Add Project'} btnIcon={<AddIcon style={{ width: "2rem", height: "2rem" }} />} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} iconPosition={"left"} />
                    </div> */}
                </div>
                <div className={cssClasses.gridWrapper}>
                    <Datagrid pageChanged={pageChanged} hideFooter={false} columns={projectGridColums} rows={allProjects} />
                </div>
            </div>
        </div>
    )
}
